import { Component, Injector, OnInit, inject } from "@angular/core";
import { PageKind } from "jk-service";
import { JackBaseComponentModule } from 'jk-service';
import { MaterialModule } from "jk-service";
import { JkaggridComponent } from "jk-advcom";
import { Stkpi01DetailComponent } from "../stkpi01/stkpi01-detailPkg.component";
import { StkwlService } from "../services/Stkwl.service";
import { StkwlEditComponent } from "../stkwl-edit/stkwl-edit.component";

//追蹤股票建立 單身:筆記STKWL
@Component({
  selector: 'app-stkpi19-detail',
  standalone: true,
  imports: [
    MaterialModule,
    JackBaseComponentModule,
    JkaggridComponent,
  ],
  templateUrl: './stkpi19-detailPkg.component.html',
  styleUrls: [],
})
export class Stkpi19DetailComponent extends Stkpi01DetailComponent implements OnInit {
  override _programId = 'stkpi19-detail';
  constructor() {
    const injector = inject(Injector);
    super();
    this.srv = new StkwlService();
    this.pageKind = PageKind.detail;
    this.srv.programId = this.programId; // ### modi,不要亂改
    this.srv.linkMasterFields = 'WL001=TM002'; // ### modi,不要亂改
    this.masterEditPage = StkwlEditComponent;
    this.srv.programId = 'stock'; // ### modi,不要亂改

    this.constructorInit(); // ###

  }
}
